import { Sparkles } from "lucide-react";

export const Marquee = ({ items }) => {
  const list = items && items.length ? items : ["Aesthetic Dermatology", "Dubai Healthcare City"];
  const row = [...list, ...list];
  return (
    <div className="overflow-hidden border-y border-[#D4AF37]/20 bg-[#1A1615] py-5" data-testid="treatments-marquee" aria-hidden="true">
      <div className="animate-marquee flex w-max items-center">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap font-serif text-xl italic text-[#F3E5AB]/90 sm:text-2xl">{t}</span>
            <Sparkles className="mx-8 h-3.5 w-3.5 shrink-0 text-[#D4AF37]" />
          </span>
        ))}
      </div>
    </div>
  );
};
